import type { PropsWithChildren } from "react"
import { createContext, useCallback, useRef } from "react"

import { ToastHub } from "@/features/toast/ui/ToastHub"

type ToastFunction = (message: string, duration?: number) => void

type AddToastFunction = (params: { message: string; duration: number }) => void

export const ToastContext = createContext<ToastFunction | undefined>(undefined)

export function ToastProvider({ children }: PropsWithChildren<any>) {
  const addToastRef = useRef<AddToastFunction | null>(null)

  const addToast = useCallback((message: string, duration = 4000) => {
    if (addToastRef.current) addToastRef.current({ message, duration })
  }, [])

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <ToastHub>
        {(add: AddToastFunction) => {
          addToastRef.current = add
        }}
      </ToastHub>
    </ToastContext.Provider>
  )
}
